import { BASE_PATH } from '../../constants/paths';

type LinkShape = {
  href: string;
  target: '_blank' | '_self';
  rel?: 'nofollow';
};

/**
 * URLs which follow the same /blog pattern but aren't owned by this Next.js application
 * Treat them as non-blog internal paths
 */
const nonNextBlogPaths = ['/blog/updates'];

/**
 * Given an href (not config.basePath aware) string output appropriate href, target, and rel
 */
export const urlParser = (href: string): LinkShape => {
  const isBlogUrl =
    // Fully qualified internal blog URLs
    /zapier(?:-staging)?[.]com[/]blog[/]?/i.test(href) ||
    // Absolute Blog URLs
    href.startsWith(BASE_PATH);

  if (isBlogUrl) {
    const path = href.replace(/.*?[.]com([/]blog.*)/, '$1');

    const isNonNextBlogPath = nonNextBlogPaths.some((nonNextBlogPath) =>
      path.startsWith(nonNextBlogPath),
    );
    // Open all non-blog internal paths in new tab
    const target = isNonNextBlogPath ? '_blank' : '_self';

    return { href: path, target };
  }

  const isInternalUrl =
    // Fully qualified internal non-blog URLs
    /(?:zapier|zapier-staging)[.]com/i.test(href) ||
    // Absolute URLs
    href.startsWith('/');

  if (isInternalUrl) {
    return { href, target: '_blank' };
  }

  // Handle hash-only URLs
  if (href.startsWith('#')) {
    return { href, target: '_self' };
  }

  // Fallback behavior
  return { href, rel: 'nofollow', target: '_blank' };
};
